import React from 'react'

import { Loader } from '@/components/ui'
import { useAuth } from '@/hooks'
import type { ApiService } from '@/types/dashboard-types'

import { apiService } from './apiService'

export type ApiContextType = {
  api: ApiService
  uid?: string
}

export const ApiContext = React.createContext<ApiContextType | undefined>(undefined)

export const ApiProvider = ({ children }: { children: React.ReactNode }) => {
  const { user, isLoading, isAuthenticated } = useAuth()

  const api = apiService
  console.log({ apiInProvider: !!api })
  const value = React.useMemo(() => ({ uid: user?.id, api }), [user?.id, api])

  if (isLoading || !isAuthenticated) {
    return <Loader fullScreen />
  }

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>
}

export type { ApiService }
